import React from "react";
import { IArticle } from "../interfaces/IArticle";
import { Typography } from "@mui/material";
import CmsGrid from "./CmsGrid";
import DefaultSpacing from "../../cmp/page/DefaultSpacing";
import CmsImage from "./CmsImage";

const CmsArticle : React.FC<IArticle> = ({headline, subheadline, content, author, image}) => {
    return <DefaultSpacing margin={{size: 'medium', applyTo: 'all'}}>
        <article>
            {image && <CmsImage {...image} />}
            <Typography variant="h1" sx={{marginTop: '1em'}}>{headline}</Typography>
            <Typography variant="h2" sx={{margin: '0.5em 0'}}>{subheadline}</Typography>
            {content && <CmsGrid {...content} />}
            <Typography variant="body2" sx={{margin: '0.5em 0', textAlign: 'right'}}>&copy; {author}</Typography>
        </article>
    </DefaultSpacing>
}

export default CmsArticle;